import React from 'react';
import { EMeasureUnit } from '../../../../../../../store/commomTypes';
import { IOpenOrderQuantities } from '../../../../../../../store/ducks/long-steel-orders/types';
import { ProgressVolumeBar, VolumeTotal } from './styles';

interface IProductStatusBarColumnProps {
  quantities: IOpenOrderQuantities;
}

const ProductStatusBarColumn: React.FC<IProductStatusBarColumnProps> = ({
  quantities
}) => {
  const getPercentage = (field: string): number => {
    const requestedQuantity =
      quantities.requestedQuantity === ''
        ? 0
        : Number(quantities.requestedQuantity);
    const fieldValue = field === '' ? 0 : Number(field);
    return (fieldValue / requestedQuantity) * 100;
  };

  const getValueToShow = (
    field: string,
    measureUnit?: EMeasureUnit
  ): string => {
    const percentage = getPercentage(field);

    const value =
      measureUnit === EMeasureUnit.KG || measureUnit === EMeasureUnit.T
        ? Number(field).toFixed(2).toString().replace('.', ',')
        : Number(field);

    return percentage > 15
      ? `${value} ${measureUnit || quantities.requestedMeasureUnit}`
      : '';
  };

  return (
    <>
      <ProgressVolumeBar>
        {Number(quantities.billedQuantity) > 0 && (
          <div
            className="billed"
            style={{ width: `${getPercentage(quantities.billedQuantity)}%` }}
          >
            {getValueToShow(
              quantities.billedQuantity,
              quantities.billedMeasureUnit
            )}
          </div>
        )}

        {Number(quantities.deliveryQuantity) > 0 && (
          <div
            className="delivery"
            style={{ width: `${getPercentage(quantities.deliveryQuantity)}%` }}
          >
            {getValueToShow(
              quantities.deliveryQuantity,
              quantities.deliveryMeasureUnit
            )}
          </div>
        )}

        {Number(quantities.shipmentQuantity) > 0 && (
          <div
            className="shipment"
            style={{ width: `${getPercentage(quantities.shipmentQuantity)}%` }}
          >
            {getValueToShow(
              quantities.shipmentQuantity,
              quantities.shipmentMeasureUnit
            )}
          </div>
        )}

        {Number(quantities.pendingQuantity) > 0 && (
          <div
            className="pending"
            style={{ width: `${getPercentage(quantities.pendingQuantity)}%` }}
          >
            {getValueToShow(
              quantities.pendingQuantity,
              quantities.pendingMeasureUnit
            )}
          </div>
        )}
      </ProgressVolumeBar>

      <VolumeTotal>
        Solicitado:
        <strong>
          {' ' +
            getValueToShow(
              quantities.requestedQuantity,
              quantities.requestedMeasureUnit
            )}
        </strong>
      </VolumeTotal>
    </>
  );
};

export default ProductStatusBarColumn;
